import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { Button, CheckBox, FDropdown, Input ,GeneralDropdown} from "../../../../components";
import { useTranslation } from "react-i18next";
import { addNotificationAdmin } from "../../../../services/apis/notification";
import { toast } from "react-toastify";
import { toastConfig } from "../../../../helpers/helper";
import { useLocation, useNavigate } from "react-router-dom";
import { getUsersAdmin } from "../../../../services/apis/user";

const Add = () => {
    const {t} = useTranslation()
    const navigate = useNavigate()
    const [users,setUsers] = useState([])
    const location = useLocation()
    console.log(location?.state?.data)
    const [frequencyTypes,setFrequencyTypes] = useState([
        {value:"DAILY",label:t('adminNotification.add.daily')},
        {value:"EVERY_2_DAYS",label:t('adminNotification.add.twoDays')},
        {value:"EVERY_3_DAYS",label:t('adminNotification.add.threeDays')},
        {value:"EVERY_4_DAYS",label:t('adminNotification.add.fourDays')},
        {value:"EVERY_5_DAYS",label:t('adminNotification.add.fiveDays')},
        {value:"EVERY_6_DAYS",label:t('adminNotification.add.sixDays')},
        {value:"WEEKLY",label:t('adminNotification.add.weekly')},
        {value:"EVERY_2_WEEKS",label:t('adminNotification.add.twoWeek')},
        {value:"MONTHLY",label:t('adminNotification.add.monthly')},
        
    ])

    const [loading,setLoading] = useState(false)
    const customUsers = location?.state?.data?.customUsers?.map((user) => ({
      value: user.id,
      label: user.fullName ?? user.phone,
    }));
    const { register, handleSubmit, control, watch } = useForm({
        defaultValues: {
          text:location?.state?.data == null ? "" : location?.state?.data?.text,  
          scheduledTime:location?.state?.data == null ? "" : location?.state?.data?.scheduledTime,
          type: location?.state?.data == null ? "ONE_TIME" : location?.state?.data?.type,
          recipientType:location?.state?.data == null ? "CUSTOM_USERS" : location?.state?.data?.recipientType,
          recurrenceFrequency:location?.state?.data == null ? null : location?.state?.data?.recurrenceFrequency,
          customUserIds: customUsers?.map((option)=> option.value) || [],
        },
      });

  const onSubmit = (data) => {
    console.log("Form Data:", data);
    try {
      console.log(data.customUserIds)
      const normalize =  data.customUserIds.map(item => 
  typeof item === 'object' && item !== null ? item.value : item
);

console.log(normalize); 
      data.customUserIds = normalize
        const response = addNotificationAdmin(data)
        console.log(response)
        toast.success(
            t('adminNotification.add.successMessage'),
            toastConfig,
            setLoading(false)
          );
          setTimeout(() => {
            navigate('/admin/notifications');
          }, 1500);
        
    } catch (error) {
        console.log(error)
    }
  };

  const recipientType = watch("recipientType");
  const type = watch("type");


  const fetchUsers = async () => {

    console.log("test")
    // setLoading(true);

    try {

      const response = await getUsersAdmin("",0,1000000);
      console.log(response)

  const userOptions = response.content.map((user) => ({
    value: user.id,
    label: user.fullName == null || user.fullName.trim() === '' ? user.phone : user.fullName,
  }));
      setUsers(userOptions)
    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    fetchUsers();
  }, []);

  return (
    <div className="bg-gradient-to-b from-[#FFFFFF] to-[#D7E2FF] p-10">
        <div className="w-[90%] mr-auto ml-auto">
    <form onSubmit={handleSubmit(onSubmit)} className="p-4 space-y-4 rounded-md">
        <div className="text-lg font-700 text-[#3E0292] text-center">{t('adminNotification.add.title')}</div>
           <div>
        <label className="block text-sm font-400 text-[#3E0292] mt-10 mb-3">{t('adminNotification.add.notification')}</label>
        {/* <input
          type="text"
          {...register("text", { required: "Text is required" })}
          className="border p-2 w-full rounded-[12px] border-[#3E0292]"
        /> */}
         <textarea
        //   type="text"
          rows={4}
          placeholder={t("adminNotification.add.placeholder")}
          {...register("text", { required: "Text is required" })}
          className="border p-2 w-full rounded-[12px] border-[#3E0292] resize-none"
        />
        {/* {errors.text && <p className="text-red-500">{errors.text.message}</p>} */}
      </div>

      {/* Type (Radio Buttons) */}
      <div>
        <label className="block text-sm font-400 text-[#3E0292] mt-5 mb-3">{t('adminNotification.add.type')}</label>
        <div className="grid grid-cols-2 gap-3">
        <label>
          <input className="appearance-none w-5 h-5 rounded-[5px] border border-[#3E0292] checked:bg-[#3E0292] checked:border-transparent focus:outline-none" type="radio" value="ONE_TIME" {...register("type", { required: true })} /> {t('adminNotification.add.oneTime')}
        </label>
        <label className="ml-4">
          <input className="appearance-none w-5 h-5 rounded-[5px] border border-[#3E0292] checked:bg-[#3E0292] checked:border-transparent focus:outline-none" type="radio" value="RECURRING" {...register("type", { required: true })} /> {t('adminNotification.add.moreTime')}
        </label>
        </div>
      </div>

           {/* Schedule Time */}
           {type === "ONE_TIME" ? (
       <div>
        <label className="block text-sm font-400 text-[#3E0292] mt-5 mb-3">{t('adminNotification.add.schedualed')}</label>
        <input type="datetime-local" step="3600" {...register("scheduledTime", { required: true })} className="border p-2 rounded w-full rounded-[12px] border-[#3E0292]" />
        {/* {errors.scheduleTime && <p className="text-red-500 text-sm">Schedule time is required</p>} */}
      </div>):(
           <div>
           <label className="block text-sm font-400 text-[#3E0292] mt-5 mb-3">{t('adminNotification.add.schedualed')}</label>
           <input type="datetime-local" step="3600" {...register("scheduledTime", { required: true })} className="border p-2 rounded w-full rounded-[12px] border-[#3E0292]" />
           {/* {errors.scheduleTime && <p className="text-red-500 text-sm">Schedule time is required</p>} */}
         </div>
      )}

           {/* Frequency (Number Input) */}
           {type === "RECURRING" && (
    <GeneralDropdown
    maxWidth={false}
    control={control}
    name="recurrenceFrequency"
    label={t('adminNotification.add.frequency')}
    placeholder={t('adminNotification.add.typeFrequencyPlaceholder')}
    options={frequencyTypes}
  />
      )}


      {/* Recipient Type (Radio Buttons) */}
      <div>
        <label className="block text-sm font-400 text-[#3E0292] mt-5 mb-3">{t('adminNotification.add.typeReceipnt')}</label>
        <div className="grid grid-cols-4 gap-3">
        <label className="ml-4">
          <input  className="appearance-none w-5 h-5 rounded-[5px] border border-[#3E0292] checked:bg-[#3E0292] checked:border-transparent focus:outline-none" type="radio" value="ALL_USERS" {...register("recipientType", { required: true })} /> {t('adminNotification.add.allUsers')}
        </label>
        <label>
          <input className="appearance-none w-5 h-5 rounded-[5px] border border-[#3E0292] checked:bg-[#3E0292] checked:border-transparent focus:outline-none" type="radio" value="ALL_BUYERS" {...register("recipientType", { required: true })} /> {t('adminNotification.add.buyers')}
        </label>
        <label className="ml-4">
          <input className="appearance-none w-5 h-5 rounded-[5px] border border-[#3E0292] checked:bg-[#3E0292] checked:border-transparent focus:outline-none" type="radio" value="ALL_MEDIATORS" {...register("recipientType", { required: true })} /> {t('adminNotification.add.mediators')}
        </label>
        <label className="ml-4">
          <input  className="appearance-none w-5 h-5 rounded-[5px] border border-[#3E0292] checked:bg-[#3E0292] checked:border-transparent focus:outline-none" type="radio" value="CUSTOM_USERS" {...register("recipientType", { required: true })} /> {t('adminNotification.add.chooseUsers')}
        </label>
        </div>
      </div>


      {/* User IDs (Multi-Select Checkboxes) */}
      {recipientType === "CUSTOM_USERS" && (
      <div>
              <FDropdown
              control={control}
              name="customUserIds"
              label={t('adminNotification.add.users')}
              placeholder={t('adminNotification.add.selectUsers')}
              // icon={userMail}
              options={users}
            />
      </div>)}

      {/* Submit Button */}
      <div className="grid grid-cols-2 gap-3 max600:grid-cols-1 w-[60%] mr-auto ml-auto">
      <button type="submit" className="bg-[#3E0292] text-center text-white p-3 rounded-[12px] w-[100%] mt-10">{t('adminNotification.edit.save')}</button>
      <button type="button" className="bg-red-500 text-center text-white p-3 rounded-[12px] w-[100%] mt-10" onClick={()=>navigate("/admin/notifications")}>{t('adminNotification.add.cancel')}</button>

      </div>
    </form>
    </div>
    </div>
  );
};

export default Add;